// extracted by mini-css-extract-plugin
module.exports = {"h1":"Title_h1__2OA7x","h1Text":"Title_h1Text__12ZaJ"};